module.exports = require("./fr-MU.d.ts");